import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { AccountCreationError } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  error: AccountCreationError;
  createAccount(data: Boundaries["createAccount"]["request"]): void;
}

function useAccountCreation(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(selector.isAccountCreationRequestPending),
    isRequestSuccess: useSelector(selector.isAccountCreationRequestSuccess),
    isRequestFailure: useSelector(selector.isAccountCreationRequestFailure),
    error: useSelector(selector.getAccountCreationError),
    createAccount: core.createAccount,
  };
}

export { useAccountCreation };
